module.exports = __webpack_public_path__ + "static/Impact-1-f519144ef5ccd4de6c65a4cf1ba688a4.jpg";